import gql from 'graphql-tag';

export const CREATE_EXAM_CONFIG = gql`
  mutation CreateExamConfig($input: ExamConfigInput!) {
    createExamConfig(input: $input) {
      _id
    }
  }
`;

export const UPDATE_EXAM_CONFIG = gql`
  mutation UpdateExamConfig($id: MOID!, $input: ExamConfigInput!) {
    updateExamConfig(id: $id, input: $input)
  }
`;

export const ADD_GIFTS_TO_EXAM_CONFIG = gql`
  mutation AddGiftsToExamConfig($input: GiftsToExamConfigInput!) {
    addGiftsToExamConfig(input: $input)
  }
`;

export const UNLINK_GIFTS_FROM_EXAM_CONFIG = gql`
  mutation UnlinkGiftsFromExamConfig($input: UnlinkGiftsFromExamConfigInput!) {
    unlinkGiftsFromExamConfig(input: $input)
  }
`;
